import { observer } from 'mobx-react-lite';
import { Form, Formik } from 'formik';
import { Receipt } from 'lucide-react';
import Popup from '../../../../components/common-components/pop-up/Popup';
import FormPopupFooter from '../../../../components/form-components/common-components/FormPopupFooter';
import { useStore } from '../../../../hooks/useStore';
import { ExpenseFormSchema } from '../../../../schemas/ExpenseFormSchema';
import { toast } from 'react-toastify';
import ExpenseFormFields from './ExpenseFormFields';
import {
  buildExpenseFormData,
  getDefaultExpenseFormValues,
  type ExpenseFormValues,
} from './expenseFormUtils';
import styles from './NewExpensePopup.module.css';

const NewExpensePopup = () => {
  const { popupStore, expenseStore } = useStore();

  const handleClose = () => {
    popupStore.setIsNewExpenseOpen(false);
  };

  const handleSubmit = async (values: ExpenseFormValues) => {
    const formData = buildExpenseFormData(values);
    if (!formData) {
      toast.error('Geçerli bir miktar giriniz');
      return;
    }

    const response = await expenseStore.createExpense(formData);
    if (!response?.error) {
      popupStore.setIsNewExpenseOpen(false);
    }
  };

  if (!popupStore.isNewExpenseOpen) {
    return null;
  }

  return (
    <Formik
      initialValues={getDefaultExpenseFormValues()}
      validationSchema={ExpenseFormSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Popup
          isOpen={popupStore.isNewExpenseOpen}
          onClose={handleClose}
          title="Yeni Harcama Kaydı"
          description="Yeni harcama kaydı oluşturun"
          variant="success"
          icon={<Receipt size={22} strokeWidth={2} />}
          footer={() => <FormPopupFooter onClose={handleClose} />}
        >
          <Form className={styles.form}>
            <ExpenseFormFields />
          </Form>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(NewExpensePopup);
